import { render, staticRenderFns } from "./VCurrencyInput.vue?vue&type=template&id=29c0ea81&scoped=true"
import script from "./VCurrencyInput.vue?vue&type=script&lang=js"
export * from "./VCurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./VCurrencyInput.vue?vue&type=style&index=0&id=29c0ea81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c0ea81",
  null
  
)

export default component.exports